namespace advisorop.components.servicer{

    
    export class CuManagerController {

        $router;
        manager: domains.IManager = {};
        managers: Array<domains.IManager> = [];
        //managerProduct: domains.IManagerProduct = {};
        updatingAccountLadda: boolean = false;
        cuManagerProductController: servicer.CuManagerProductController;

        mappingType: domains.ExternalMappingType = domains.ExternalMappingType.MANAGERID_TO_CUSTODIANID;
        externalSystemDataMappings: domains.IExternalSystemDataMapping[] = [];
        mappingExternalSystemType = domains.ExternalSystemType.BACK_OFFICE;


        static $inject = ["servicerService"];
        constructor(private servicerService: services.ServicerService) {
        }

        showProductTypes(): boolean {
            return this.manager && this.manager.id > 0;
        };

        createManager(): void {
            this.updatingAccountLadda = true;

            this.servicerService.createManager(this.manager)
                .then((response) => {
                    toastr.success("Manager has been successfully created.");
                    this.manager = response.data;
                }).
                catch(err => {
                    toastr.error("Cannot add new manager. " + err.data);
                }).
                finally(() => {
                    this.updatingAccountLadda = false;
                });
        };
        
        updateManager(): void {
            this.updatingAccountLadda = true;

            this.servicerService.updateManager(this.manager)
                .then((response) => {
                    this.manager = response.data;
                    toastr.success("Manager has been updated successfully");
                })
                .catch(err => {
                    toastr.error("Unable to update manager. Error" + err.status + " " + err.data);
                }).finally(() => {
                    this.updatingAccountLadda = false;
                });
        };

        deleteManager(manager: domains.IManager): void {

            if (!window.confirm("Are you sure ?"))
                return;
            
            this.servicerService.deleteManager(manager.id)
                .then((response) => {
                    toastr.success("Manager deleted.");
                    this.$router.navigate(['Dashboard']);
                })
                .catch(err => {
                    toastr.error("Cannot delete this manager!");
                });
        };

        clearInputs() {
            this.manager = {};
        };


        onProductTypesChange(managerProductType: any): void {
            this.cuManagerProductController.loadManagerProductTypes(this.manager.id);
        }

        externalMappingChanged(data: domains.IExternalSystemDataMapping[]) {
            this.externalSystemDataMappings = data;

            //console.log("externalSystemDataMappings", data);
        }

        //onManagerProductChange(managerProduct: domains.IManagerProduct): void {
        //    this.managerProduct = managerProduct;
        //}

        bindCuManagerProduct(ctrl: servicer.CuManagerProductController): void {
            this.cuManagerProductController = ctrl;
        };


        loadManager(managerId: number): void {
            this.servicerService.getManagerById(managerId)
                .then((response) => {
                    this.manager = response.data;
                })
                .catch(err => {
                    toastr.error("Cannot load manager!");
                });
        };

        $routerOnActivate(next, previous) {
            if (next.params.managerId) {
                this.loadManager(next.params.managerId);
            }
        }

        $onInit(): void {
        }
    }


    class CuManager implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = CuManagerController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cu-manager.html";
        }
    }
    angular.module(Constants.APP).component("cuManager", new CuManager());
}